/* eslint-disable implicit-arrow-linebreak */
import React, { useEffect } from 'react';
import { TableColumn } from 'react-data-table-component';
import { useActions } from 'src/hooks/useActions';
import { useTypedSelector } from 'src/hooks/useTypedSelector';
import { IBenefit } from 'src/interfaces';
import { removeForbiddenWords } from 'src/utils/removeForbiddenWords';
import { benefitsForbiddenWords } from '../..';
import { DefaultTable } from '../../../../components/default-table';

const BenefitsTable: React.FC = () => {
  const { data, loading } = useTypedSelector(state => state.benefits);
  const { getBenefits } = useActions();

  useEffect(() => {
    getBenefits();
  }, []);

  const columns: TableColumn<IBenefit>[] = [
    {
      name: 'name',
      selector: (row: IBenefit) => removeForbiddenWords(row.benefitName, benefitsForbiddenWords),
      sortable: true,
    },
  ];

  return (
    <DefaultTable columns={columns} data={data.benefits} noTableHead progressPending={loading} pagination={false} />
  );
};

export default BenefitsTable;
